module.exports = __webpack_public_path__ + "img/noCharts.f751d3d4.svg";